import React from 'react';
import classnames from 'classnames';

import { ResponsiveImage } from 'components/ui';

import type { IContentfulImage } from 'types';

import styles from './AlphaTemplateBannerBlock.module.scss';

interface Props {
  image: IContentfulImage,
  responsiveImage: IContentfulImage,
  alt?: string,
  innerClassName?: string,
  imageClassName?: string
}

const AlphaTemplateBannerBlock = (props: Props) => {

  const {
    image, responsiveImage, alt, innerClassName, imageClassName
  } = props;

  const { height: imageHeight, width: imageWidth, url: imageSrc } = image || {};
  const { height: responsiveImageHeight, width: responsiveImageWidth, url: responsiveImageSrc } = image || {};

  if (!image || !responsiveImage) return null;

  return (
    <div className={styles.root}>
      <div className={classnames(styles.inner, innerClassName)}>
        <div className={classnames(styles.image, imageClassName)}>
          <ResponsiveImage
            desktopProps={{
              height: imageHeight,
              width: imageWidth,
              src: imageSrc,
              alt,
              priority: true
            }}
            responsiveProps={{
              height: responsiveImageHeight,
              width: responsiveImageWidth,
              src: responsiveImageSrc,
              alt,
            }}
            optimize
            quality={100}
          />

        </div>
      </div>
    </div>
  );
};

export default AlphaTemplateBannerBlock;
